import { useState } from "react";
import { Euro, eur, txt, fmt, Toggle, Field, Note, InputCard, ResultCard } from "./shared";
import { useLang } from "@/lib/i18n";

const RATES = [
  { id: "20", label: "20 %", value: 0.2 },
  { id: "9", label: "9 %", value: 0.09 },
  { id: "0", label: "0 %", value: 0 },
];

export const VatCalc = () => {
  const [mode, setMode] = useState("net");
  const [rateId, setRateId] = useState("20");
  const [amount, setAmount] = useState("1000");
  const { t } = useLang();
  const s = t.calc.vat;
  const num = parseFloat(amount.replace(",", ".")) || 0;
  const rateObj = RATES.find((r) => r.id === rateId);

  const net = mode === "net" ? num : num / (1 + rateObj.value);
  const vat = net * rateObj.value;
  const gross = net + vat;

  const rows = [
    { label: s.rows.net, ...eur(net), testid: "vat-row-net" },
    { label: `${s.rows.vat} (${rateObj.label})`, ...eur(vat), testid: "vat-row-vat" },
    { label: s.rows.gross, ...eur(gross), testid: "vat-row-gross" },
    { label: s.rows.rate, ...txt(rateObj.label), testid: "vat-row-rate" },
  ];

  return (
    <>
      <InputCard kicker={s.kicker}>
        <Toggle
          testidPrefix="vat-mode"
          value={mode}
          onChange={setMode}
          options={[
            { id: "net", label: s.net2gross },
            { id: "gross", label: s.gross2net },
          ]}
        />
        <Toggle testidPrefix="vat-rate" value={rateId} onChange={setRateId} options={RATES} />
        <Field id="vat-amount" testid="vat-amount-input" label={mode === "net" ? s.netLabel : s.grossLabel} value={amount} onChange={setAmount} />
        <Note>{s.note}</Note>
      </InputCard>
      <ResultCard
        title={s.title}
        service={s.service}
        note={s.note}
        label={mode === "net" ? s.resultGross : s.resultNet}
        main={<Euro value={mode === "net" ? gross : net} />}
        mainText={`${fmt(mode === "net" ? gross : net)} €`}
        rows={rows}
      />
    </>
  );
};
